import { motion, useScroll, useSpring } from "framer-motion";

/**
 * ScrollProgress - A progress bar showing page scroll position
 */
const ScrollProgress = ({ 
  position = "top", // "top" | "bottom"
  color = "bg-gradient-to-r from-marine-500 to-cyan-400",
  height = "h-1"
}) => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  
  return (
    <motion.div
      className={`fixed left-0 right-0 ${position === "top" ? "top-0" : "bottom-0"} ${height} ${color} z-50 origin-left`}
      style={{ scaleX }}
    />
  );
};

export default ScrollProgress;
